module.exports = __webpack_public_path__ + "21ce12fa7f4a1728ec086fedc1fc7cad.jpg";